import { Enum } from "../entity/Enum";
export const localEnums: {
  [x: string]: Enum[];
} = {
  // FactoryTypeEnum: [
  //   {
  //     desc: "自有工厂",
  //     code: "自有工厂",
  //   },
  //   {
  //     desc: "合作工厂",
  //     code: "合作工厂",
  //   },
  // ],
  // CapacityProductTypeEnum: [
  //   {
  //     desc: "成品",
  //     code: "成品",
  //   },
  //   {
  //     desc: "面辅料",
  //     code: "面辅料",
  //   },
  // ],
};
